// Splits strings obtained from inputs into standard format for the app
export default function splitInputString(str) {
	const array = str
		.split(/[\n,;]+/)
		.map(el => el.trim())
		.filter(el => !!el === true);
	return [...new Set(array)];
}
